import React, { forwardRef, useImperativeHandle, useState } from 'react';
import useLazy from '@/hooks/useLazy';
import dynamic from 'next/dynamic';

const AffiliateShareClaimPop = dynamic(() => import('./content'), { ssr: false });

const AffiliateShareClaim = forwardRef((props: any, ref) => {
  const { show, hide, visible, loaded } = useLazy();
  useImperativeHandle(ref, () => {
    return {
      show,
      hide
    };
  });
  return <>{!!loaded && <AffiliateShareClaimPop visible={visible} onCancel={hide} {...props} />}</>;
});

export default AffiliateShareClaim;
